import { action } from 'satcheljs';

export const onHelpInfoCalloutOpened = action('onHelpInfoCalloutOpened ', (popupId: string, locale?: string) => ({ popupId, locale }));

export const onHelpInfoChanged = action('onHelpInfoChanged', (helpInfo?: string) => ({ helpInfo }));
